import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="glass-card-md p-8" data-testid="terms-content">
          <div className="flex items-center mb-6">
            <FileText className="w-10 h-10 text-blue-500 mr-3" />
            <h1 className="text-4xl sm:text-5xl tracking-tight font-semibold text-white">Kullanım Şartları</h1>
          </div>
          <div className="prose prose-slate max-w-none">
            <p className="text-white/60 mb-4">Son Güncelleme: 2026</p>
            <p className="text-white/70 mb-4">Doktor Cebinde platformunu kullanarak aşağıdaki şartları kabul etmiş olursunuz.</p>
            
            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Hizmet Tanımı</h2>
            <p className="text-white/70">Doktor Cebinde, kişisel sağlık takip ve destek platformudur. Platform kişisel takip ve destek amaçlıdır.</p>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Kullanıcı Sorumlulukları</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-2">
              <li>Doğru ve güncel bilgi sağlamak</li>
              <li>Hesap güvenliğini korumak</li>
              <li>Platformu yasal amaçlarla kullanmak</li>
            </ul>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Sınırlamalar</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-2">
              <li>Hizmeti kendi hesabınızda kullanabilirsiniz</li>
              <li>Platformun içeriğini kopyalayamaz veya dağıtamazsınız</li>
              <li>Sistemi manipule etmeye çalışamazsınız</li>
            </ul>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Değişiklikler</h2>
            <p className="text-white/70">Bu şartlar zaman zaman güncellenebilir. Önemli değişiklikler hakkında sizi bilgilendireceğiz.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;